<template>
  <Modal v-model="model" sticky reset-drag-position :title="title"  @on-cancel="cancel" footer-hide :mask="false" draggable scrollable class="message_template_pop Internal_call" width="800">
    <div class="input_single">
      <div class="font_style_set"><span style="color: #ed4014">*</span>{{inputName}}:</div>
      <Input v-model="agentNumber" class="input_content" clearable></Input>
    </div>
    <div class="fixed_table">
      <Spin size="large" fix v-if="spinShow"> <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
      <el-table v-if="transferType == '1'" style="width: 100%" class="element_table" stripe @cell-click="handleCurrentChange" :data="infoTableList">
        <el-table-column v-for="(item,index) in fieldList" align="center" :show-overflow-tooltip='true' :key="index" :prop="item.key" :label="item.title"></el-table-column>
      </el-table>
      <el-table v-if="transferType == '2'" ref="multipleTable" style="width: 100%" class="element_table" stripe @selection-change="handleSelectionChange" @cell-click="handleSelectionClick" :data="infoTableList">
        <el-table-column type="selection" width="55" align="center"> </el-table-column>
        <el-table-column v-for="(item,index) in fieldList" align="center" :show-overflow-tooltip='true' :key="index" :prop="item.key" :label="item.title"></el-table-column>
      </el-table>
    </div>
    <div class="btn_template" style="width: 100%;">
      <Button type="error"   class="cancel_btn" @click="cancel()">取消</Button>
      <Button type="primary" class="submit_btn" @click="transfer()">确定</Button>
    </div>
  </Modal>
</template>

<script>
  export default {
    name: "TransferSession",
    props: {
      showTransfer:Boolean,
      transferType: String,
      msgSource:String,
    },
    data(){
      return {
        model:false,
        agentInfo: JSON.parse(localStorage.getItem("agentInfo")), //座席信息
        agentNumber:'',
        selection:'',
        inputName:'请输入员工工号',
        spinShow:true,
        spinShowmail:true,
        tableClass: true,
        title:'转接会话',
        infoTableList:[],
        contentList: [],
        fieldList: [
          {key: "employeeName", title: "员工姓名" },
          { key: "agentNumber", title: "员工工号" },
          { key: "deptParentName", title: "员工部门" }
        ],
      }
    },
    methods:{
      cancel:function(){
        document.onkeydown = undefined;
        this.$emit("closeTransferPage",'cancel');
      },
      handleCurrentChange: function(val){
          this.agentNumber = val.agentNumber;
      },
      handleSelectionChange: function(val){
        this.agentNumber = "";
        for(let i = 0; i < val.length; i++){
          if(i == val.length-1){
            this.agentNumber += val[i].agentNumber;
          }else{
            this.agentNumber += val[i].agentNumber + ",";
          }
        }
      },
      handleSelectionClick: function(val){
        this.$refs.multipleTable.toggleRowSelection(val);
      },
      transfer:function () {
        if(!this.agentNumber){
          let tip = '';
          if(this.transferType == '1'){
            tip = "请选择转接员工";
          }else if(this.transferType == '2'){
            tip = "请选择邀请员工";
          }
          this.$alert(tip, '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        if((this.agentNumber+',').indexOf(this.agentInfo.agentNumber+',') > -1){
          if(this.transferType == '1'){
            this.$Message.error("转接失败，不允许转接给当前员工");
          }else if(this.transferType == '2'){
            this.$Message.error("邀请失败，不允许邀请当前员工");
          }
              
          return false;
        }
        this.$emit("closeTransferPage",this.transferType,this.agentNumber,"");
      },
      initData:function(){
        this.spinShow=true;
        let that=this;
        let param={
          journalType:"null",
          menuId:"null",
          agentStatus: "0",
          msgSource: this.agentInfo.agentNumber,
        };
        this.$http.post("chatInterface/getFreeChatEmp.json",param) .then(function (res) {
          let result=res.data.flag;
          that.spinShow=false;
          if(result!="666"){
            that.$alert(res.data.msg, '提示', {
              confirmButtonText: '确定'
            });
            return false;
          }
          that.infoTableList= res.data.obj.list.content;
        });
      },
    },
    watch:{
      showTransfer:function () {
        this.model=this.showTransfer;

        if(this.showTransfer){
            if(this.transferType == '1'){
                this.title = "转接会话";
            }else if(this.transferType == '2'){
                this.title = "邀请会话";
            }
          this.initData();
        }else{
          this.agentNumber = "";
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/OnlineService/TransferSession.vue